/**
 * Jerarquía de roles para enforcement en cliente/servidor.
 * OWNER > ADMIN > AGENT > VIEWER.
 * OWNER (dueño del sistema, Silva Notion) reserva las superficies sensibles:
 * API keys, consumo en USD/tokens, límites de gasto, audit log, telemetría.
 * El ADMIN (cliente) conserva TODO lo operativo. La regla es de API (403),
 * nunca solo de UI: los datos reservados no viajan al navegador de un ADMIN.
 * TECNICO queda FUERA de la jerarquía de lectura (rank 0): un técnico inicia
 * sesión pero no pasa ningún `requireRole` por jerarquía; su acceso se concede
 * por scoping explícito (su vista de trabajos, capa de operaciones).
 */
export const ROLE_RANK = {
    OWNER: 4,
    ADMIN: 3,
    AGENT: 2,
    VIEWER: 1,
    TECNICO: 0,
};
export function hasRole(role, min) {
    return ROLE_RANK[role] >= ROLE_RANK[min];
}
//# sourceMappingURL=user.js.map